import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, NEVER, throwError } from 'rxjs';
import { SalesService } from '../../shared/services/sales.service';
import { Sale } from '../../shared/interfaces/sale';
import { DOCUMENT } from '@angular/common';

export const saleResolver: ResolveFn<Sale | null> = (route) => {
    const salesService = inject(SalesService);
    const router = inject(Router);
    const doc = inject(DOCUMENT);

    const encoded = route.paramMap.get('encoded');

    // Fairview Chrysler accidentally printed out a sale instance link as QR code
    // This temporarily redirects it to sale link. Remove once the promo is finished.
    if (encoded === 'MzAyNDoyMzAwOjE5OjM0Nw') {
        doc.location.replace('/sl/QkYyXzM4Mw');
        return NEVER;
    } else if (encoded === 'MzAyNDo5NTA6NzQ6MjEzNQ') {
        // Temporary redirect of a sale instance link to its sale link. Remove once the promo is finished.
        doc.location.replace('/sl/QkYyXzIxMTc');
        return NEVER;
    }

    return salesService.fromUrl(encoded).pipe(
        catchError((err) => {
            console.error('Failed to resolve sale:', err);

            if (err.status === 422) {
                router.navigate(['/sale/404'], { skipLocationChange: true });
                return NEVER;
            }

            return throwError(() => new Error(`Error while fetching sale in SaleResolver: ${err.message}`));
        }),
    );
};
